import { render, staticRenderFns } from "./GoodsSeriesInspirationEdit.vue?vue&type=template&id=685576b4&"
import script from "./GoodsSeriesInspirationEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsSeriesInspirationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports